/* Utility functions for Uploadcare */

import {UploadClient} from '@uploadcare/upload-client';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const typedWindow = window as any;

export function getFileUrl(uuid: string): string {
  const origin = typedWindow.appConfig.uploadcareOrigin;
  return `${origin}/${uuid}/`; // CDN link
}

export type Transformations = {
  name: string;
  width: number;
  height: number;
}[];

export function getImageUrl(
  uuid: string,
  transformations?: Transformations,
): string {
  const origin = typedWindow.appConfig.uploadcareOrigin;
  const transfos = transformations
    ? transformations
        .map(oneTransfo => {
          let params;
          if (oneTransfo.name === 'scale_crop') {
            params = `${oneTransfo.width}x${oneTransfo.height}/center/`;
          } else if (oneTransfo.name === 'preview') {
            params = `${oneTransfo.width}x${oneTransfo.height}/`;
          }
          return `-/${oneTransfo.name}/${params}`;
        })
        .join('')
    : '';
  return `${origin}/${uuid}/${transfos}/-/progressive/yes/-/quality/lighter/`; // CDN link
}

export function dataUriToFile(dataUri: string, name: string): File {
  // from http://stackoverflow.com/questions/12168909/blob-from-dataurl
  const Base64Marker = ';base64,';
  let parts;
  let contentType;
  let raw;
  if (dataUri.indexOf(Base64Marker) === -1) {
    parts = dataUri.split(',');
    contentType = parts[0].split(':')[1];
    raw = decodeURIComponent(parts[1]);
    return new File([raw], name, {type: contentType});
  }
  parts = dataUri.split(Base64Marker);
  contentType = parts[0].split(':')[1];
  raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; i++) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new File([uInt8Array], name, {type: contentType});
}

export function uploadScreenshot(dataUri: string): Promise<string> {
  const screenshotFile = dataUriToFile(dataUri, 'screenshot');
  const uploadClient = new UploadClient({
    publicKey: typedWindow.UPLOADCARE_PUBLIC_KEY,
  });
  return uploadClient
    .uploadFile(screenshotFile, {publicKey: typedWindow.UPLOADCARE_PUBLIC_KEY})
    .then(file => file.uuid);
}
